import { BaseTag } from '@invara-dev/react-base';
import { EntityNoteType } from '../../../enums/common/EntityNoteType';

type Props = {
  noteType: EntityNoteType | undefined;
};

export const EntityNoteTypeBadge = (props: Props) => {
  const noteTypeMap: { [key in EntityNoteType]?: { label: string; colorPalette: string } } = {
    [EntityNoteType.Basic]: { label: 'Basic', colorPalette: 'orange' },
    [EntityNoteType.AgentNote]: {
      label: 'Agent',
      colorPalette: 'green'
    },
    [EntityNoteType.CodeRed]: {
      label: 'Code Red',
      colorPalette: 'red'
    },
    [EntityNoteType.Issue]: { label: 'Issue', colorPalette: 'orange' },
    [EntityNoteType.Hotel]: { label: 'Hotel', colorPalette: 'purple' },
    [EntityNoteType.Client]: { label: 'Client', colorPalette: 'yellow' },
    [EntityNoteType.Frontier]: {
      label: 'Frontier',
      colorPalette: 'orange'
    },
    [EntityNoteType.OBTNote]: {
      label: 'OBT Note',
      colorPalette: 'blue'
    }
  };

  // Retrieve the color and label for the current noteType
  const tagInfo = props.noteType !== undefined ? noteTypeMap[props.noteType] : null;

  // Render the tag if tagInfo exists, otherwise fallback to a default message
  return tagInfo ? (
    <BaseTag colorPalette={tagInfo.colorPalette}>{tagInfo.label}</BaseTag>
  ) : (
    <BaseTag colorPalette='gray'>Unknown Type</BaseTag>
  );
};
